import { useContext, useState } from "react";

import { EditOutlined, DeleteOutlineOutlined, Add } from "@material-ui/icons";

import { Grid, Typography } from "@material-ui/core";

import Fieldset from "../../../../components/basics/Fieldset";
import Chip from "../../../../components/basics/Chip";
import { HeaderAccordion, Line } from "../styles/ClassificacaoServico";
import SpeedDialErp from "../../../../components/speeddial/SpeedDialErp";
import IconBtn from "../../../../components/buttons/IconBtn";
import TableDefault from "../../../../components/grid/TableDefault";

import ModalClassifCentroNegocio from "./ModalClassifCentroNegocio";
import ModalEditCentroNegocio from "./ModalEditCentroNegocio";

import { ClassificacaoServicoContext } from "../contexts/ClassificacaoServicoContext";
import useClassificacaoServicoController from "../controllers/ClassificacaoServicoController";

const AccordionClassifCategorias = () => {
  const { tableSetCostCenters, setTableSetCostCenters } = useContext(
    ClassificacaoServicoContext
  );

  const [openClassifBusinessCenter, setOpenClassifBusinessCenter] =
    useState(false);

  const [openEditBusiness, setOpenEditBusiness] = useState(false);

  const [selectedIndex, setSelectedIndex] = useState(null);

  const { confirmDeleteItem, handleOpenBusinessCenter } =
    useClassificacaoServicoController();

  const columnsCostCenter = [
    {
      disabled: true,
      id: "acoes",
      label: "Ações",
      align: "center",
      format: (item) => (
        <SpeedDialErp
          actions={[
            {
              icon: <EditOutlined />,
              name: "Editar",
              action: () => {
                setSelectedIndex(item.index);
                setOpenEditBusiness(true);
              },
            },
            {
              icon: <DeleteOutlineOutlined />,
              name: "Excluir",
              action: () =>
                confirmDeleteItem(
                  item.index,
                  tableSetCostCenters,
                  setTableSetCostCenters
                ),
            },
          ]}
        />
      ),
    },
    {
      label: "Descrição",
      id: "costDescription",
      style: { minWidth: 200 },
    },
    {
      label: "Porcentagem",
      id: "costPercentage",
    },
  ];
  return (
    <>
      {openClassifBusinessCenter && (
        <ModalClassifCentroNegocio
          open={openClassifBusinessCenter}
          setOpen={setOpenClassifBusinessCenter}
        />
      )}

      {openEditBusiness && (
        <ModalEditCentroNegocio
          open={openEditBusiness}
          setOpen={setOpenEditBusiness}
          index={selectedIndex}
        />
      )}

      <Fieldset
        titulo={
          <HeaderAccordion>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs>
                <Chip label="CATEGORIAS" />
              </Grid>
              <Grid item>
                <IconBtn
                  onClick={(event) => {
                    event.stopPropagation();
                    handleOpenBusinessCenter(setOpenClassifBusinessCenter);
                  }}
                >
                  <Add />
                </IconBtn>
              </Grid>
            </Grid>
          </HeaderAccordion>
        }
        bgcolor="white"
        textcolor="black"
        accordion
        defaultExpanded={false}
      >
        <Line container justifyContent="center">
          <Grid item xs={12}>
            {tableSetCostCenters.length > 0 ? (
              <TableDefault
                values={tableSetCostCenters}
                tableTitle=""
                columns={columnsCostCenter}
              />
            ) : (
              <Typography align="center">
                Empresa não possui cadastro de categorias.
              </Typography>
            )}
          </Grid>
        </Line>
      </Fieldset>
    </>
  );
};

export default AccordionClassifCategorias;
